'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, useEffect } from 'react';
import { styled } from 'styled-components';
import { DefaultsContext, dontForwardProps, isReactDevelopment } from '../../../util';
import { getSize } from '../utils';
const MaskSpan = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-10faqfi-0"
})(["display:inline-block;position:relative;vertical-align:middle;", " background:currentColor;width:", ";height:", ";mask-image:url(", ");mask-size:contain;mask-repeat:no-repeat;"], ({
  $color
}) => $color && `color: ${$color};`, ({
  $size
}) => getSize($size), ({
  $size
}) => getSize($size), ({
  $src
}) => $src);
const formatPath = (path, useCustomRoot) => {
  const CDN_ROOT = useCustomRoot ? 'https://assets.asurion-ui.my.asurion53.com/icons/' : `https://assets.asurion-ui.my.asurion53.com/icons/nova/`;
  if (!path.endsWith('.svg')) {
    path = path + '.svg';
  }
  return CDN_ROOT + encodeURI(path);
};
const placeholderIconSrc = 'icon-placeholder';
export const SSR = /*#__PURE__*/React.forwardRef(({
  'aria-label': ariaLabel,
  src = '',
  size,
  color,
  useCustomRoot,
  ...props
}, fRef) => {
  const {
    iconSize
  } = useContext(DefaultsContext);
  const [iconExists, setIconExists] = React.useState(true);
  useCustomRoot ??= src.startsWith('microns/');

  // Checks if the icon exists in the CDN.
  // If it exists, the mask-image style above has already requested it
  // If it doesn't exist, change the mask-image URL to the placeholder
  useEffect(() => {
    setIconExists(true);
    const abortController = new AbortController();
    fetch(formatPath(src, useCustomRoot), {
      signal: abortController.signal
    }).then(res => {
      setIconExists(res.ok);
      if (!res.ok && isReactDevelopment()) {
        console.warn(`Icon '${src}' does not exist in the CDN. Falling back to '${placeholderIconSrc}'. Please check the path or use a different icon.`);
      }
    }).catch(err => {
      if (err.name !== 'AbortError') {
        setIconExists(false);
      }
    });
    return () => abortController.abort();
  }, [src, useCustomRoot]);
  const iconSrc = iconExists ? src : placeholderIconSrc;
  size ||= iconSize ?? 'normal';
  return /*#__PURE__*/React.createElement(MaskSpan, _extends({
    $size: size,
    $src: formatPath(iconSrc, useCustomRoot),
    $color: color,
    ref: fRef,
    "data-aui": "icon",
    "data-icon-name": iconSrc,
    "aria-label": ariaLabel || props.title,
    role: ariaLabel || props.title ? 'img' : 'presentation'
  }, props));
});